<div class="d-flex justify-content-between align-items-center">
  <cf-timezone-select
    [disabled]="disabled"
    [(ngModel)]="timezone"
    [timeFormat]="time_format"
    [date]="date"
    (ngModelChange)="timezoneChange.emit(timezone)"
  ></cf-timezone-select>

  <div class="tw:ml-2 text-right text-nowrap">
    <cf-switch [ngModel]="timeFormat" (change)="formatChange.emit($event)" labelPosition="before">
      <span class="tw:text-sm tw:mr-2">
        {{ "components.time_settings.am_pm" | translate }}
      </span>
    </cf-switch>
    <span class="tw:ml-2 tw:text-sm">{{ "components.time_settings.24h" | translate }}</span>
  </div>
</div>
